import { useState } from 'react';

import * as MovimentoPedidoPadraoAPI from '../../../../../api/movimentoPedidoPadrao';

export function usePedidoPadraoModule({ dados, setFlashMessage }) {
    const [pedidoPadraoLoading, setPedidoPadraoLoading] = useState(false);
    const [pedidosPadrao, setPedidosPadrao] = useState([]);

    const carregarPedidosPadrao = async ({ parceiroId, empresaId }) => {
        if (!parceiroId || !empresaId) {
            setPedidosPadrao([]);
            return [];
        }

        try {
            setPedidoPadraoLoading(true);

            const response = await MovimentoPedidoPadraoAPI.listarPorParceiro({
                parceiroId,
                empresaId,
            });

            setPedidosPadrao(response || []);

            return response || [];
        } catch (error) {
            console.error('Erro ao carregar pedidos padrão:', error);

            setPedidosPadrao([]);

            return [];
        } finally {
            setPedidoPadraoLoading(false);
        }
    };

    const obterPedidoPadrao = async (uuid) => {
        if (!uuid) return null;

        try {
            setPedidoPadraoLoading(true);

            return await MovimentoPedidoPadraoAPI.obterPorUuid(uuid);
        } catch (error) {
            console.error('Erro ao obter pedido padrão:', error);
            return null;
        } finally {
            setPedidoPadraoLoading(false);
        }
    };

    const salvarComoPedidoPadrao = async ({ descricao, diaSemana }) => {
        const itens = dados?.movimentoItems || [];

        const itensValidos = itens.filter((item) => {
            const quantidade = Number(item.quantidade || 0);
            const pedido = item.pedido === true;

            return pedido || quantidade > 0;
        });

        if (!dados?.empresaId) {
            setFlashMessage('Empresa não informada.', 'warning');
            return { ok: false };
        }

        if (!dados?.parceiroId) {
            setFlashMessage('Cliente não informado.', 'warning');
            return { ok: false };
        }

        if (!itensValidos.length) {
            setFlashMessage('Nenhum item com quantidade para salvar como pedido padrão.', 'warning');
            return { ok: false };
        }

        if (!descricao) {
            setFlashMessage('Informe uma descrição para o pedido padrão.', 'warning');
            return { ok: false };
        }

        const payload = {
            empresaId: dados.empresaId,
            parceiroId: dados.parceiroId,
            tabelaPrecoId: dados.tabelaPrecoId || null,
            descricao,
            diaSemana: diaSemana ?? null,

            itens: itensValidos.map((item, index) => ({
                produtoId: item.produtoId,
                embalagemId: item.embalagemId || null,
                quantidade: Number(item.quantidade || 0),
                tabelaPrecoId: item.tabelaPrecoId || null,
                ordem: index + 1,
            })),
        };

        const existente = pedidosPadrao.find((pedido) => {
            return (
                Number(pedido.empresaId) === Number(dados.empresaId) &&
                Number(pedido.parceiroId) === Number(dados.parceiroId) &&
                String(pedido.descricao || '')
                    .trim()
                    .toLowerCase() ===
                    String(descricao || '')
                        .trim()
                        .toLowerCase()
            );
        });

        const response = existente?.uuid
            ? await MovimentoPedidoPadraoAPI.editar(existente.uuid, payload)
            : await MovimentoPedidoPadraoAPI.cadastrar(payload);

        setFlashMessage(
            existente?.uuid ? 'Pedido padrão atualizado com sucesso.' : 'Pedido padrão salvo com sucesso.',
            'success'
        );

        await carregarPedidosPadrao({
            parceiroId: dados.parceiroId,
            empresaId: dados.empresaId,
        });

        return {
            ok: true,
            data: response,
        };
    };

    const removerPedidoPadrao = async (uuid) => {
        if (!uuid) {
            setFlashMessage('Selecione um pedido padrão para excluir.', 'warning');
            return { ok: false };
        }

        await MovimentoPedidoPadraoAPI.remover(uuid);

        setFlashMessage('Pedido padrão excluído com sucesso.', 'success');

        await carregarPedidosPadrao({
            parceiroId: dados.parceiroId,
            empresaId: dados.empresaId,
        });

        return { ok: true };
    };
    return {
        pedidoPadraoLoading,
        pedidosPadrao,
        setPedidosPadrao,

        carregarPedidosPadrao,
        obterPedidoPadrao,
        salvarComoPedidoPadrao,
        removerPedidoPadrao,
    };
}
